// extracted by mini-css-extract-plugin
export default {"tab-icon":"bottom-navigation_tab-icon__-Q+f6","tab-active":"bottom-navigation_tab-active__Pgo3V"};